// modules
import moment from 'moment'

import httpClient, { catchError } from '@emmacare/common/api/httpClient'

import {
  setPatientPointsReport,
  setPatientPointsReportLoading
} from 'src/store/modules/reports'

// constants
import {
  DATE_TIME_FORMAT_FOR_SERVER,
  EXPORT_PATIENT_POINTS_REPORT,
  GET_PATIENT_POINTS_REPORT
} from 'src/constants'
import { exportReport } from 'src/utils/Functions'

export const getPatientPointsReport =
  (config = {}) =>
  async (dispatch) => {
    const { params = {}, query = {} } = config

    try {
      const { items = [], meta = {} } = await httpClient.request({
        method: 'get',
        url: {
          pathname: GET_PATIENT_POINTS_REPORT,
          params,
          query
        }
      })

      dispatch(setPatientPointsReport(items))

      return meta
    } catch (err) {
      catchError(err)

      return false
    }
  }

export const exportPatientPointsReport =
  (config = {}) =>
  async (dispatch) => {
    dispatch(setPatientPointsReportLoading(true))

    const updConfig = {
      pathname: EXPORT_PATIENT_POINTS_REPORT,
      ...config
    }
    const fileNameDefault = `patient_points_report_${moment().format(
      DATE_TIME_FORMAT_FOR_SERVER
    )}.xls`

    await exportReport(updConfig, fileNameDefault)

    dispatch(setPatientPointsReportLoading(false))
  }
